import React from 'react';
import { Link } from 'react-router-dom';

const AllGalleries = () => {
  const galleries = [
    {
      id: 1,
      title: 'Weddings',
      slug: 'weddings',
      coverImage: '/Weddings/wedding cover.JPG',
      description: 'Beautiful wedding moments',
      count: '9 photos'
    },
    {
      id: 2,
      title: 'Portraits',
      slug: 'portraits',
      coverImage: '/Portrait/IMG_4114.jpg',
      description: 'Stunning portrait photography',
      count: '14 photos'
    },
    {
      id: 3,
      title: 'Live Performance',
      slug: 'live-performance',
      coverImage: '/Live performance/IMG_0054.jpg',
      description: 'Energy of live shows',
      count: '38 photos'
    },
    {
      id: 4,
      title: 'Graduation',
      slug: 'graduation',
      coverImage: '/Graduation/IMG_5367.jpg',
      description: 'Celebrating achievements',
      count: '11 photos'
    },
    {
      id: 5,
      title: 'Engagement',
      slug: 'engagement',
      coverImage: '/Engagement/IMG_1703.jpg',
      description: 'Love and commitment',
      count: '8 photos'
    }
  ];

  return (
    <div className="pt-20 md:pt-24 min-h-screen bg-light">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-forest via-secondary to-forest text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-64 h-64 bg-accent rounded-full blur-3xl animate-float"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-white rounded-full blur-3xl animate-float" style={{ animationDelay: '2s' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4">
            All Galleries
          </h1>
          <p className="text-xl text-gray-200">
            Explore our complete collection of photography
          </p>
        </div>
      </section>

      {/* Galleries Grid */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {galleries.map((gallery) => (
              <Link
                key={gallery.id}
                to={`/gallery/${gallery.slug}`}
                className="group relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 aspect-[4/3]"
              >
                <div className="absolute inset-0">
                  <img
                    src={gallery.coverImage}
                    alt={gallery.title}
                    width="800"
                    height="600"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/40 to-transparent"></div>
                <div className="absolute inset-0 flex flex-col justify-end p-6">
                  <h3 className="font-serif text-3xl font-bold text-white mb-2">
                    {gallery.title}
                  </h3>
                  <p className="text-white/90 mb-2">{gallery.description}</p>
                  <p className="text-accent font-semibold">{gallery.count}</p>
                </div>
                {/* View Icon */}
                <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="bg-white/20 backdrop-blur-sm rounded-full p-3">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-forest mb-6">
            Ready to Create Your Story?
          </h2>
          <p className="text-xl text-secondary mb-8">
            Let's capture your special moments together
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="inline-block bg-forest text-white font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Book a Session
            </Link>
            <Link
              to="/"
              className="inline-block bg-card text-forest font-semibold px-10 py-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AllGalleries;
